// Generated by CoffeeScript 1.9.2
var currentWidth, onResize, raf, subscribers, ticking, update;

raf = require('raf');

currentWidth = void 0;

subscribers = [];

ticking = false;

if (typeof window !== "undefined" && window !== null) {
  currentWidth = window.innerWidth;
}

onResize = function() {
  if (!ticking) {
    ticking = true;
    return raf(update);
  }
};

update = function() {
  var i, len, subscriber;
  currentWidth = window.innerWidth;
  for (i = 0, len = subscribers.length; i < len; i++) {
    subscriber = subscribers[i];
    subscriber(currentWidth);
  }
  return ticking = false;
};

if (typeof window !== "undefined" && window !== null) {
  window.addEventListener("resize", onResize);
}

module.exports = {
  on: function(subscribeFn) {
    subscribeFn(currentWidth);
    return subscribers.push(subscribeFn);
  },
  off: function(subscribeFn) {
    return subscribers.splice(subscribers.indexOf(subscribeFn), 1);
  }
};



//////////////////
// WEBPACK FOOTER
// ../~/react-page-width/dist/resizeListener.js
// module id = 416
// module chunks = 0